import isEmpty from "lodash/isEmpty";
import { CounterpartyProfileWrite } from "@wingspanhq/wingspan-api-sdk";

/**
 * Builds the v3 payee `CounterpartyProfileWrite` from the single "full name" +
 * company fields the payer edits.
 *
 * v1 stored one `payeeName` string; v3's profile wants `individual.firstName` /
 * `individual.lastName` separately, so the first whitespace-delimited token is
 * the first name and the rest is the last name (lossy for multi-part names — the
 * contractor confirms/corrects it during onboarding). Shared by the create flow
 * and the contractor-edit modal so the split stays identical across both writes.
 *
 * Returns `undefined` when neither name nor company is present, so an optional
 * create payload can omit `profile` entirely.
 */
export const selectorCounterpartyProfileWrite = (fields: {
  name?: string;
  company?: string;
}): CounterpartyProfileWrite | undefined => {
  const profile: CounterpartyProfileWrite = {};

  const trimmedName = fields.name?.trim();
  if (trimmedName) {
    const [firstName, ...rest] = trimmedName.split(/\s+/);
    profile.individual = {
      firstName,
      lastName: rest.join(" ") || undefined
    };
  }

  const trimmedCompany = fields.company?.trim();
  if (trimmedCompany) {
    profile.company = { doingBusinessAs: trimmedCompany };
  }

  return isEmpty(profile) ? undefined : profile;
};
